var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "c3t40oxh0a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D163",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFA440",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5H8V2H2v.5H.5c-.3 0-.5.2-.5.5v1.2c0 1.15.85 2.1 2 2.25v.05c0 1.45 1 2.65 2.35 2.95L4 10.5H2.85c-.2 0-.4.15-.45.35L2 12h6l-.4-1.15a.48.48 0 0 0-.45-.35H6l-.35-1.05C7 9.15 8 7.95 8 6.5v-.05c1.15-.15 2-1.1 2-2.25V3c0-.3-.2-.5-.5-.5zM2 5.45C1.45 5.3 1 4.8 1 4.2v-.7h1v1.95zM6 7l-1-.55L4 7l.25-1-.75-1h1.05L5 4l.45 1H6.5l-.75 1L6 7zm3-2.8c0 .6-.45 1.15-1 1.25V3.5h1v.7z",
    transform: "translate(0 -2)",
    fill: "url(#c3t40oxh0a)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.e4f0d6f1b12bb14ba571e448822984d0.svg";
export { ForwardRef as ReactComponent };